import { render, staticRenderFns } from "./ItemTemplateName.vue?vue&type=template&id=71a17c66&scoped=true&"
import script from "./ItemTemplateName.vue?vue&type=script&lang=js&"
export * from "./ItemTemplateName.vue?vue&type=script&lang=js&"
import style0 from "./ItemTemplateName.vue?vue&type=style&index=0&id=71a17c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a17c66",
  null
  
)

export default component.exports